<ion-text *ngIf="data" class="ids" color="dark">
    <span>{{ data }}</span>
</ion-text>